import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {VM} from '@hetao/scratch-core';
import {openBackWithoutSubmit, openWhiteList} from '../reducers/modals';
import {back} from '../lib/app/api';
import MenuBarComponent from '../components/menu-bar/menu-bar.jsx';
import scratchTester from '../lib/scratch-tester/index.js';

class MenuBar extends React.Component {
    constructor (props){
        super(props);
        this.handleBackCheck = this.handleBackCheck.bind(this);
        this.handleSaveAnswer = this.handleSaveAnswer.bind(this);
        this.looseTargetsEqual = this.looseTargetsEqual .bind(this);
        this.handleOpenWhiteList = this.handleOpenWhiteList .bind(this);
        document.documentElement.lang = props.currentLocale;
    }

    looseTargetsEqual () {
        const initVMTargets = this.props.initVMTargets;
        const currVMTargets = this.props.vm.runtime.targets;

        let targetEqual = true;

        if (Object.keys(initVMTargets).length !== currVMTargets.length) {
            targetEqual = false;
            return targetEqual;
        }


        for (let i = 0; i < currVMTargets.length; i++){

            const currTarget = currVMTargets[i];

            if (!initVMTargets.hasOwnProperty(currTarget.id)) {
                targetEqual = false;
                return targetEqual;
            }

            const currBlocksKeys = Object.keys(currTarget.blocks._blocks);
            const initBlocksKeys = initVMTargets[currTarget.id];

            if (initBlocksKeys.length !== currBlocksKeys.length) {
                targetEqual = false;
                return targetEqual;
            }


            for (let j = 0; j < initBlocksKeys.length; j++){
                const initBlockKey = initBlocksKeys[j];
                if (!currBlocksKeys.includes(initBlockKey)) {
                    targetEqual = false;
                    return targetEqual;
                }
            }
        }

        return targetEqual;
    }

    handleBackCheck (){

        if (this.looseTargetsEqual()){
            back();
        } else {
            this.props.onBackWithoutSubmit();
        }
    }

    handleOpenWhiteList (){
        this.props.onpenWhiteList();
    }

    handleSaveAnswer (){
        scratchTester.recordAnswer();
        window.alert('答案保存成功');
    }

    render (){
        return (
            <MenuBarComponent
                isEdit={this.props.isEdit}
                onBackCheck={this.handleBackCheck}
                onOpenWhiteList={this.handleOpenWhiteList}
                onSaveAnswer={this.handleSaveAnswer}
            />
        );
    }
}

MenuBar.propTypes = {
    currentLocale: PropTypes.string,
    initVMTargets: PropTypes.objectOf(PropTypes.array),
    isEdit: PropTypes.bol,
    onBackWithoutSubmit: PropTypes.func,
    onpenWhiteList: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};
const mapStateToProps = state => ({
    currentLocale: state.locales.locale,
    initVMTargets: state.scratchGui.vmStatus.initVMTargets,
    vm: state.scratchGui.vm
});

const mapDispatchToProps = dispatch => ({
    onBackWithoutSubmit: () => dispatch(openBackWithoutSubmit()),
    onpenWhiteList: () => dispatch(openWhiteList())
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuBar);
